/* eslint max-len: 0 */
import React, { SVGProps } from 'react';

const IdentityProtection = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="icon icon--identityProtection"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.66634 4.00001C6.56177 4.00001 5.66634 4.89544 5.66634 6.00001V6.66668C5.66634 7.77125 6.56177 8.66668 7.66634 8.66668H8.33301C9.43758 8.66668 10.333 7.77125 10.333 6.66668V6.00001C10.333 4.89544 9.43758 4.00001 8.33301 4.00001H7.66634ZM7.66634 5.33334C7.29815 5.33334 6.99967 5.63182 6.99967 6.00001V6.66668C6.99967 7.03487 7.29815 7.33334 7.66634 7.33334H8.33301C8.7012 7.33334 8.99967 7.03487 8.99967 6.66668V6.00001C8.99967 5.63182 8.7012 5.33334 8.33301 5.33334H7.66634Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.6663 2.00001L13.3118 2.13547C12.027 2.26395 10.735 1.97453 9.62777 1.3102L7.99967 0.333344L6.37158 1.3102C5.26437 1.97453 3.97239 2.26395 2.68758 2.13547L1.33301 2.00001V7.55874C1.33301 9.90049 2.56167 12.0705 4.5697 13.2754L7.99967 15.3333L11.4296 13.2754C13.4377 12.0705 14.6663 9.90049 14.6663 7.55874V2.00001ZM13.333 3.47247C11.7995 3.60223 10.263 3.24627 8.94178 2.45353L7.99967 1.88826L7.05757 2.45353C5.73632 3.24628 4.1998 3.60223 2.66634 3.47247V7.55874C2.66634 8.98517 3.23619 10.332 4.21723 11.3189L4.25703 11.2788C5.07046 10.4603 6.17677 10 7.33075 10H8.54068C9.74707 10 10.8971 10.5028 11.7158 11.3844C12.7374 10.392 13.333 9.017 13.333 7.55874V3.47247ZM10.6425 12.1927C10.0837 11.6439 9.32958 11.3333 8.54068 11.3333H7.33075C6.56692 11.3333 5.83324 11.6246 5.27812 12.1455L7.99967 13.7784L10.6425 12.1927Z"
        fill="white"
      />
    </svg>
  );
};

IdentityProtection.displayName = 'identityProtection';

export default IdentityProtection;
